export class Currencies {
    constructor() {
        this.center = document.getElementById("center");
        this.currency = document.getElementById("currency");
        if (this.center === null || this.currency === null) {
            return;
        }
        $("#center").on("change", () => this.onCenterChanged());
        $("#currency").on("change", () => this.onCurrencyChanged());
        this.onCenterChanged();
        this.onCurrencyChanged();
    }
    get selectedCenterCurrencyCode() {
        const currentCenterIndex = this.center.selectedIndex;
        return this.center.options[currentCenterIndex].dataset["currencyCode"];
    }
    get selectedCurrencyOption() {
        return this.currency.options[this.currency.selectedIndex];
    }
    onCurrencyChanged() {
        this.changeSymbols();
    }
    onCenterChanged() {
        if (this.selectedCurrencyOption === undefined ||
            this.selectedCurrencyOption.defaultSelected) {
            return;
        }
        const currencyCode = this.selectedCenterCurrencyCode;
        $(this.currency).val(currencyCode);
        $(this.currency).trigger("change");
        this.changeSymbols();
    }
    changeSymbols() {
        const { selectedCurrencyOption } = this;
        if (selectedCurrencyOption === undefined) {
            return;
        }
        const symbolBefore = selectedCurrencyOption.dataset["symbolBefore"];
        const symbolAfter = selectedCurrencyOption.dataset["symbolAfter"];
        Currencies.changeSymbol(symbolBefore, $(".currencyBefore"));
        Currencies.changeSymbol(symbolAfter, $(".currencyAfter"));
    }
    static changeSymbol(symbol, input) {
        if (symbol === undefined || symbol.trim() == "") {
            input.addClass("hidden");
        }
        else {
            input.removeClass("hidden");
            input.html(symbol);
        }
    }
}
